import { Component, Input, OnInit } from '@angular/core';

import { SectionTitleConfig } from './../shared.interface';

@Component({
    selector: 'app-section-title',
    templateUrl: './section-title.component.html',
    styleUrls: ['./section-title.component.scss'],
})
export class SectionTitleComponent implements OnInit {
    @Input() sectionTitleConfig: SectionTitleConfig;

    constructor() {}

    ngOnInit(): void {}
}
